// Pre-send validation for Data Entry file imports.
//
// A row's dateTime is valid only when it parses AND round-trips exactly through
// toISOString() or toUTCString(). This mirrors the backend rule in
// functions/lib/rowDateTime.js — addMultipleData rejects (and buildDocArray drops)
// anything else — so a bad file is caught here before anything is sent. On
// fuelsqcv2-colonial 2026-10-29 an import with shifted Sample ID / Date-Time
// columns produced dateTime: null on every row and was dropped silently.
export function isValidIsoDateTime(value) {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return false;
  return parsed.toISOString() === value || parsed.toUTCString() === value;
}

// `parsedRows` is the import parser's output as [{ row, rowNumber }], where
// rowNumber is the 1-based spreadsheet row (the header is row 1). Returns the
// row numbers whose dateTime is invalid.
export function getInvalidDateTimeRowNumbers(parsedRows) {
  return (parsedRows || [])
    .filter(({ row }) => !isValidIsoDateTime(row?.dateTime))
    .map(({ rowNumber }) => rowNumber);
}
